import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";

export interface VisualContextType {
  showSideMenu: boolean;
  toggleSideMenu: () => void;
}

export const VisualContext = createContext<VisualContextType | undefined>(undefined);

export const useVisualContext = () => {
  return defined(use(VisualContext));
};
